var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconclock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_199_4799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.47295 0.113281C11.538 0.113281 14.8331 3.4084 14.8331 7.47343C14.8331 11.5385 11.538 14.8336 7.47295 14.8336C3.40791 14.8336 0.112793 11.5385 0.112793 7.47343C0.112793 3.4084 3.40791 0.113281 7.47295 0.113281ZM7.47295 1.38913C4.11254 1.38913 1.38864 4.11303 1.38864 7.47343C1.38864 10.8338 4.11254 13.5577 7.47295 13.5577C10.8334 13.5577 13.5573 10.8338 13.5573 7.47343C13.5573 4.11303 10.8334 1.38913 7.47295 1.38913ZM7.19324 3.72266C7.54555 3.72266 7.83116 4.00827 7.83116 4.36059V7.82715L10.5678 8.76115C10.8756 8.86613 11.051 9.1831 10.9867 9.49351L10.9656 9.57085C10.8519 9.9043 10.4894 10.0824 10.1559 9.96869L6.98731 8.88797C6.72897 8.79986 6.55531 8.55715 6.55531 8.2842V4.36059C6.55531 4.00827 6.84092 3.72266 7.19324 3.72266Z",
    fill: "#E2E6E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_199_4799"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.01,
    height: 15.01,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconclock);
export default __webpack_public_path__ + "static/media/iconclock.e541b59ce8a6f2e5a9605789f886f021.svg";
export { ForwardRef as ReactComponent };